import { Progress } from 'antd';
import type { ReactNode } from 'react';

import { Theme, useTheme } from '../../theme';
import { Tooltip } from '../Tooltip/Tooltip';

import './ProgressBar.scss';

export function ProgressBar({
  label,
  percent,
  showData = true,
  height = 23,
  fill = 'primary',
}: {
  label?: ReactNode;
  percent?: number;
  showData?: boolean;
  height?: number;
  fill?: `#${string}` | keyof Theme['colors'];
}) {
  const theme = useTheme();
  const strokeColor = fill.startsWith('#')
    ? fill
    : theme.colors[fill as keyof Theme['colors']];
  const roundedPercent = Math.round(percent || 0);

  return (
    <div className="suntex-progress-bar">
      {label && <div className="suntex-progress-bar-label">{label}</div>}
      <Tooltip
        classNames={{ root: 'progress-tooltip' }}
        placement="top"
        arrow={false}
        title={
          percent != null ? `${roundedPercent}% Complete` : 'Data not available'
        }
      >
        <Progress
          status="normal" // disables checkmark on 100%
          strokeColor={strokeColor}
          percent={roundedPercent}
          size={['100%', height]}
          showInfo={showData}
        />
      </Tooltip>
    </div>
  );
}
